"use client";

import * as stylex from "@stylexjs/stylex";
import { Spinner } from "@softmax/design-system";
import { styles } from "./onboarding-room.styles";

export function OnboardingLoading() {
  return (
    <main {...stylex.props(styles.room)}>
      <output {...stylex.props(styles.loading)}>
        <Spinner />
        <p {...stylex.props(styles.copy)}>Loading</p>
      </output>
    </main>
  );
}
